import "./utils/globalStyles/normalize.css";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <App />
  </>
);
